import { useFormikContext } from "formik";

export default function KmMottors() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { values, setFieldValue } = useFormikContext<any>();

  return (
    <div className="flex flex-col gap-2">
      <label htmlFor="odometerVehicle" className="font-semibold">
        Digite o valor do Hodômetro
      </label>
      <input
        id="odometerVehicle"
        name="odometerVehicle"
        type="number"
        value={values.odometerVehicle}
        onChange={(e) => setFieldValue("odometerVehicle", e.target.value)}
        className="border rounded px-3 py-2 text-black"
        placeholder="Digite o hodômetro da moto"
      />
    </div>
  );
}
